/**
 * Cache identity for workspace connections.
 *
 * Typed factories rather than inline arrays so the query and every
 * invalidation that follows a mutation cannot drift apart (constitution
 * §2.6) — same shape `secretKeys`/`triggerKeys` already establish. Every key
 * is scoped by workspace: a connection belongs to exactly one.
 *
 * `all` exists alongside `list`/`detail` as the broad invalidation target: a
 * connection mutation should refresh both its own detail read and the list
 * row showing its `trigger_profile_count`.
 */
export const connectionKeys = {
  all: (workspaceId: string) => ['connections', workspaceId] as const,
  list: (workspaceId: string) => ['connections', workspaceId, 'list'] as const,
  detail: (workspaceId: string, connectionId: string) =>
    ['connections', workspaceId, 'detail', connectionId] as const,
  catalog: (workspaceId: string) =>
    ['connections', workspaceId, 'catalog'] as const,
  /** Under `all`, so every connection mutation re-tests on next read. */
  health: (workspaceId: string, connectionId: string) =>
    ['connections', workspaceId, 'health', connectionId] as const,
};
